<template>
  <div
    class="divider-widget"
    :class="widgetClasses"
    :style="{ ...widgetStyles, textAlign: (widget as any).alignment || 'center' }"
  >
    <hr :style="dividerStyles" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { DividerWidget } from '@/types/pagebuilder'
import { useWidgetStyles } from '@/composables/useWidgetStyles'

interface Props {
  widget: DividerWidget
}

const props = defineProps<Props>()
const { widgetStyles, widgetClasses } = useWidgetStyles(props.widget)

const dividerStyles = computed(() => {
  const w = props.widget as any
  const widthVal = w.width ? (typeof w.width === 'number' ? w.width + '%' : w.width) : '100%'
  return {
    borderStyle: w.style || 'solid',
    borderWidth: `${w.thickness || '1px'} 0 0 0`,
    borderColor: w.color || '#dee2e6',
    width: widthVal,
    margin: w.margin ? w.margin + 'px 0' : '1.5rem 0',
    display: 'inline-block',
  }
})
</script>

<style scoped>
.divider-widget {
  width: 100%;
}
</style>
